import React, { useState, useEffect } from 'react';
import { IonApp, IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Route, Redirect } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import HomePage from './pages/HomePage';
import TreeProfile from './pages/TreeProfile';
import UserProfile from './pages/UserProfile';
import LoginPage from './pages/LoginPage';
import AdminDashboard from './pages/AdminDashboard';
import AddTree from './pages/AddTree';
import config from './config'; // Import config
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 > Date.now()) {
        console.log('Token valid, setting user');
        setCurrentUser(decoded);
      } else {
        console.log('Token expired, clearing');
        localStorage.removeItem('token');
      }
    }
    console.log('App mounted, currentUser:', currentUser);
  }, []);

  const setUser = (token) => {
    const user = jwtDecode(token);
    setCurrentUser(user);
    localStorage.setItem('token', token);
  };

  const logout = () => {
    fetch(`${config.API_BASE_URL}/logout`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(() => {
        setCurrentUser(null);
        localStorage.removeItem('token');
      })
      .catch(err => console.error('Logout failed:', err));
  };

  return (
    <IonApp>
      <IonReactRouter>
        <IonRouterOutlet>
          <Route path="/" exact render={() => <HomePage user={currentUser} logout={logout} />} />
          <Route path="/trees/:id" component={TreeProfile} />
          <Route path="/user-profile" render={() => (currentUser ? <UserProfile user={currentUser} /> : <Redirect to="/login" />)} />
          <Route path="/login" render={() => (!currentUser ? <LoginPage setUser={setUser} /> : <Redirect to="/" />)} />
          <Route path="/admin" render={() => (currentUser && currentUser.is_admin ? <AdminDashboard /> : <Redirect to="/" />)} />
          <Route path="/add-tree" component={AddTree} />
          <Route render={() => <Redirect to="/" />} />
        </IonRouterOutlet>
      </IonReactRouter>
    </IonApp>
  );
}

export default App;